import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { ConnectionInfo } from '@/types/poc/libp2p';

export const getConnectionInfoThunk = createAppAsyncThunk<
  { sixId: string; connections: ConnectionInfo[] },
  { sixId: string }
>(
  'connection/getConnectionInfo',
  ({ sixId }, { extra: { pocServices } }) => ({
    sixId,
    connections: pocServices.p2pStackManagerService.getConnectionInfo(sixId),
  })
);
